import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/logo2.png";
import College from "../assets/clg.png";

export default function NewNavbar() {
  const location = useLocation();

  function isActive(path) {
    return location.pathname === path;
  }

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCommitteeOpen, setIsCommitteeOpen] = useState(false);
  const [isVenueOpen, setIsVenueOpen] = useState(false);

  function toggleMenu() {
    setIsMenuOpen((prevState) => !prevState);
    setIsVenueOpen(false);
    setIsCommitteeOpen(false);
  }

  function toggleCommittee() {
    setIsVenueOpen(false);
    setIsCommitteeOpen((prevState) => !prevState);
  }

  function toggleVenue() {
    setIsCommitteeOpen(false)
    setIsVenueOpen((prevState) => !prevState);
  }

  return (
    <nav className="fixed top-0 z-50 bg-primary-blue text-white w-full xl:opacity-90 px-5 sm:px-10 py-4 backdrop-blur-3xl flex justify-between xl:flex-row flex-col">
      <div className="flex justify-between">
        <div
          onClick={() => (window.location.href = "/")}
          className="flex flex-row xl:w-full md:w-3/4 gap-3 cursor-pointer xl:gap-5"
        >
          <div className="flex gap-3 flex-col sm:flex-row mt-2 sm:mt-0">
            <img
              className="w-[250px] h-auto items-center align-baseline justify-center place-self-center"
              src={College}
              alt="College Logo"
            />
          </div>
          {/* <div
            className={`${isMenuOpen ? "block" : "block"} sm:block sm:w-full ml-5 sm:ml-10 2xl:ml-16 2xl:mt-5`}
          >
            <p className="sm:text-lg text-md font-bold">
              Sri Ramakrishna Engineering College
            </p>
            <p className="font-semibold sm:text-base">Coimbatore</p>
          </div> */}
        </div>

        <div
          onClick={toggleMenu}
          className="block xl:hidden text-3xl sm:text-5xl cursor-pointer"
        >
          <ion-icon
            name={isMenuOpen ? "close-outline" : "menu-outline"}
          ></ion-icon>
        </div>
      </div>

      <div className="lg:block">
        <ul
          className={`${isMenuOpen
              ? "sm:top-[60px] top-[50px] left-0 opacity-100 z-50"
              : "hidden xl:flex top-[-400px] xl:opacity-100 opacity-0"
            } flex 2xl:text-lg xl:text-xs mt-5 xl:flex-row flex-col absolute xl:static transition-all ease-in-out duration-500 w-full bg-primary-blue xl:bg-transparent pl-10 xl:pl-0 py-10 xl:py-0`}
        >
          <div className="flex xl:flex-row flex-col gap-7">
            <Link to="/">
              <li
                className={`${isActive("/") ? "font-semibold underline underline-offset-8" : ""
                  } hover:cursor-pointer hover:underline hover:underline-offset-8 hover:font-bold duration-500 font-medium`}
                onClick={toggleMenu}
              >
                Home
              </li>
            </Link>
            <Link to="/about">
              <li
                className={`${isActive("/about") ? "font-semibold underline underline-offset-8" : ""
                  } hover:cursor-pointer hover:underline hover:underline-offset-8 hover:font-bold duration-500 font-medium`}
                onClick={toggleMenu}
              >
                About Us
              </li>
            </Link>
            <div className="relative">
              <li
                className={`${isActive("/committee/organizing") ||
                    isActive("/committee/steering") ||
                    isActive("/committee/advisory")
                    ? "font-semibold underline underline-offset-8"
                    : ""
                  } hover:cursor-pointer hover:underline hover:underline-offset-8 hover:font-bold duration-500 font-medium`}
                onClick={toggleCommittee}
              >
                Committee
              </li>
              {isCommitteeOpen && (
                <ul className="absolute bg-primary-blue rounded-md shadow-lg mt-2 w-60 flex flex-col gap-2 p-3">
                  <Link to="/committee/organizing">
                    <li className="hover:cursor-pointer hover:font-bold" onClick={toggleMenu}>
                      Organizing Committee
                    </li>
                  </Link>
                  <Link to="/committee/steering">
                    <li className="hover:cursor-pointer hover:font-bold" onClick={toggleMenu}>
                      Steering Committee
                    </li>
                  </Link>
                  <Link to="/committee/advisory">
                    <li className="hover:cursor-pointer hover:font-bold" onClick={toggleMenu}>
                      Advisory Committee
                    </li>
                  </Link>
                </ul>
              )}
            </div>
            <Link to="/author">
              <li
                className={`${isActive("/author") ? "font-semibold underline underline-offset-8" : ""
                  } hover:cursor-pointer hover:underline hover:underline-offset-8 hover:font-bold duration-500 font-medium`}
                onClick={toggleMenu}
              >
                Authors
              </li>
            </Link>
            <Link to="/register">
              <li
                className={`${isActive("/register") ? "font-semibold underline underline-offset-8" : ""
                  } hover:cursor-pointer hover:underline hover:underline-offset-8 hover:font-bold duration-500 font-medium`}
                onClick={toggleMenu}
              >
                Registration
              </li>
            </Link>
          </div>
          <div className="flex xl:flex-row flex-col gap-7 mt-5 xl:mt-0 xl:ml-5">
            <Link to="/call">
              <li
                className={`${isActive("/call") ? "font-semibold underline underline-offset-8" : ""
                  } hover:cursor-pointer hover:underline hover:underline-offset-8 hover:font-bold duration-500 font-medium`}
                onClick={toggleMenu}
              >
                Call for Papers
              </li>
            </Link>
            <Link to="/speakers">
              <li
                className={`${isActive("/speakers") ? "font-semibold underline underline-offset-8" : ""
                  } hover:cursor-pointer hover:underline hover:underline-offset-8 hover:font-bold duration-500 font-medium`}
                onClick={toggleMenu}
              >
                Speakers
              </li>
            </Link>
            <div className="relative">
              <li
                className={`${isActive("/venue/") ||
                    isActive("/venue/tourism") ||
                    isActive("/venue/hotels")
                    ? "font-semibold underline underline-offset-8"
                    : ""
                  } hover:cursor-pointer hover:underline hover:underline-offset-8 hover:font-bold duration-500 font-medium`}
                onClick={toggleVenue}
              >
                Venue
              </li>
              {isVenueOpen && (
                <ul className="absolute bg-primary-blue rounded-md shadow-lg mt-2 flex flex-col w-44 gap-2 p-3">
                  <Link to="/venue/">
                    <li className="hover:cursor-pointer hover:font-bold" onClick={toggleMenu}>
                      Venue
                    </li>
                  </Link>
                  <Link to="/venue/tourism">
                    <li className="hover:cursor-pointer hover:font-bold" onClick={toggleMenu}>
                      Tourist Places
                    </li>
                  </Link>
                  <Link to="/venue/hotels">
                    <li className="hover:cursor-pointer hover:font-bold" onClick={toggleMenu}>
                      Hotels to Stay
                    </li>
                  </Link>
                </ul>
              )}
            </div>
            <Link to="/contact">
              <li
                className={`${isActive("/contact") ? "font-semibold underline underline-offset-8" : ""
                  } hover:cursor-pointer hover:underline hover:underline-offset-8 hover:font-bold duration-500 font-medium`}
                onClick={toggleMenu}
              >
                Contact
              </li>
            </Link>
          </div>
        </ul>
      </div>
    </nav>
  );
}
